<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="480px" :top="top" @close="dlogClose">
    <div class="dialog_box">
      <!-- Cont Not Unload -->
      <div class="dialogBox" v-if="dialogVal == 'ContNotUnload'">
        <p>{{ $t('enum.canNotUnload') }}</p>
      </div>
      <!-- Do you want Unload -->
      <div class="dialogBox" v-if="dialogVal == 'Unload'">
        <p class="align_c">{{ $t('enum.willUEndListIt') }} </p>
      </div>
      <!-- 查看申请历史 -->
      <div class="dialogBox dialogBox-list" v-if="dialogVal == 'VHistory'">
        <div v-if="applyHistory.length">
          <div class="dialogBox-row" v-for="(obj, kk) in applyHistory" :key="kk">
            <div class="dialogBox_box ">
              <span :class="['status-title', obj.Status == -1 || obj.Status == -2 ? 'text_red' : (obj.Status == 0 ? 'text_yellow' : 'text_greed')]">
                <img class="icon-status" :src="'/static/images/icon_' + (obj.Status == -1 || obj.Status == -2 ? 'warning' : (obj.Status == 0 ? 'time' : 'success')) + '.svg'" />
                {{ $store.state.ApplyStatus[obj.Status] }}
              </span>
            </div>
            <div class="dialogBox_box dialogBox_flex" v-if="obj.AnswerInfo">
              <span class="dialogBox_title title_color2">Answer Info:</span>
              <span style="color:#333333;">{{ obj.AnswerInfo }}</span>
            </div>
            <div class="dialogBox_box">
              <span class="dialogBox_title title_color2">Reason </span>
              <span style="display:block;color:#333333;">{{ obj.Reason }}</span>
            </div>
            <div class="dialogBox_box dialogBox_photo">
              <span class="dialogBox_title title_color2 dialogBox_photo">Photo </span>
              <div class="dialogBox_photo">
                <el-image class="active_img" v-for="(img, k) in obj.Images" :key="k" :src="img" fit="contain" lazy></el-image>
              </div>
            </div>
            <div class="dialogBox_box dialogBox_flex">
              <span class="dialogBox_title title_color2">Apply Time:</span>
              <span style="color:#333333;">{{ (new Date(obj['CreateDate'])).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="dialogBox_box">
            <!-- 暂无申请下架记录 -->
            <span class="dialogBox_title align_c color_333">{{ $t('enum.noRecord') }}</span>
          </div>
        </div>
      </div>
      <!-- 申请 -->
      <div class="dialogBox" v-if="dialogVal == 'Apply'">
        <p>
          Buyers have already bid this item. Do you want to unload it?
          <br />
          Card hobby will verify you application.
        </p>
        <div class="dialogBox_box">
          <span class="dialogBox_title title_color1"><em class="em_color">*</em>Reason</span>
          <el-input class="store_textarea" v-model="reason" type="textarea" :rows="4" placeholder="Please enter content" maxlength="300" show-word-limit>
          </el-input>
        </div>
        <div class="dialogBox_box">
          <span class="dialogBox_title title_color1"><em class="em_color">*</em>Photo</span>
          <upload-images ref="UploadImages"></upload-images>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-if="dialogVal == 'Unload'">
      <el-button @click="dlogClose">{{ $t('button.no') }}</el-button>
      <el-button type="primary" @click="dialogSwitch('Apply')">{{ $t('button.yes') }}</el-button>
    </span>
    <span slot="footer" class="dialog-footer" v-if="dialogVal == 'VHistory' || dialogVal == 'ContNotUnload'">
      <el-button type="primary" @click="dlogClose">Done</el-button>
    </span>
    <span slot="footer" class="dialog-footer" v-if="dialogVal == 'Apply'">
      <el-button @click="dlogClose">{{ $t('button.cancel') }}</el-button>
      <el-button type="primary" @click="applyUnlod">{{ $t('button.apply') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadImages from '@/components/upload-images'
export default {
  name: 'DialogUnload',
  components: { UploadImages },
  data() {
    return {
      dialogShow: true,
      dialogTitle: '',
      result: 0,
      applyHistory: [],
      reason: '',
      imageUrl: "",
      top: '15vh',
      // dialogCardObj: {},
      dialogVal: "",//dialogType
      needApply: true,//是否需要下架申请
      needApplyTst: false////是否需要下架申请?tst=true 调试申请框用
    }
  },
  props: {
    dialogCardObj: {},
    dialogType: "",
  },
  watch: {},
  created() {
    // console.log('dialog created');
    let _needApplyTst = this.$route.query.tst || '';
    this.needApplyTst = _needApplyTst;
    this.dialogVal = this.dialogType;
    this.getUnloadHistory();
  },

  mounted() {
    this.setTitle()
  },
  methods: {
    // 弹框标题
    setTitle() {
      let dialogVal = this.dialogVal;
      console.log(dialogVal);
      switch (dialogVal) {
        case 'Unload':
          this.dialogTitle = this.$t('button.endList');//"End List";
          this.top = '40vh';
          break;
        case 'Apply':
          this.dialogTitle = this.$t('button.endList');//"End List";
          this.top = '15vh';
          break;
        case 'VHistory':
          this.dialogTitle = this.$t('button.endListHistory');//"End List History";
          this.top = '15vh';
          break;
      }
    },
    // 查看申请历史、申请下架（还有直接下架） 弹框
    dialogSwitch(val) {
      let that = this;
      let needApply = that.$store.getters.applyUnload(that.dialogCardObj);//根据条件 是否需要下架申请
      // console.log('needApply:', needApply, that.applyHistory);
      if (that.applyHistory.length && that.applyHistory[0].Status != -2) {
        //不符合再申请 查看申请历史
        that.dialogVal = 'VHistory';
        that.setTitle()
      } else {
        //符合申请 去申请
        if (needApply || that.needApplyTst) {///测试用 needApplyTst
          //下架申请 框
          that.dialogVal = 'Apply';
          // that.$emit("dialogSwitch", val)
          that.setTitle()
        } else {
          //直接下架
          let params = { CommodityID: that.dialogCardObj.ID };
          that.$post('Revocation', params)
            .then((res) => {
              //console.log("axios-res:", res);
              let _type = 'success';
              if (res.result != 1) {
                _type = 'error';
              } else {
                that.$message({
                  showClose: true,
                  // message: res.msg || _type,
                  message: 'End List Successfully',
                  type: _type,
                });
              }
              that.$emit('getData');
              that.$emit('dialogClose');
              // that.dialogShow = false;
            })
            .catch((err) => { });
        }
      }

    },
    /* 申请下架 填写信息 提交 */
    applyUnlod() {
      let that = this;
      // console.log('dialogCardObj:', this.dialogCardObj.ID);
      let picList = that.$refs.UploadImages.picList;
      let images = '';
      picList.map((obj, k) => {
        let cut = k < picList.length - 1 ? ';' : '';
        images += obj.ImageUrl + cut;
      });
      let reason = that.reason;
      if (reason == '') {
        that.$message.warning("Please fill in the reasons for your application!");
      } else if (images == '') {
        that.$message.warning("Please upload pictures");
      } else {
        let params = { id: this.dialogCardObj.ID, reason: reason, images: images };
        // console.log(that.reason, images);
        that.$post('Offline', params)//申请下架
          .then((res) => {
            //console.log("axios-res:", res);
            let _type = 'success';
            if (res.result != 1) {
              _type = 'error';
            } else {
              that.$emit('getData');
              that.$refs.UploadImages.picList = [];
              that.reason = '';
              that.$message({
                showClose: true,
                // message: res.msg || _type,
                message: 'End List Successfuly',
                type: _type,
              });
            }
            that.$emit('dialogClose');
            // that.dialogShow = false;
          })
          .catch((err) => { });
      }
    },
    /* 获取申请下下架信息 */
    getUnloadHistory() {
      let that = this;
      //console.log('getUnloadHistory:', that.dialogCardObj.ID);
      var obj = that.dialogCardObj;
      let params = `?id=${obj.ID}`
      that.$get('GetOffline', params)//获取下架申请的状态
        .then((res) => {
          //console.log("axios-res:", res);
          if (res.result) {
            that.applyHistory = res.data;
            if (that.dialogVal == 'VHistory') {
              that.top = '23vh';
            }
          } else {
            if (that.dialogVal == 'VHistory') {
              that.top = '40vh';
            }
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    // 关闭弹框
    dlogClose() {
      this.applyHistory = [];
      this.$emit('dialogClose')
      // this.dialogType = '';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}

.store_textarea {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog-unload.vue